import React from 'react';

import JsonView from '@uiw/react-json-view';

import styles from '../FileViewer.module.css';

type JsonViewerProps = {
  data: object;
};

export const JsonViewer: React.FC<JsonViewerProps> = ({ data }) => {
  return (
    <div className={styles.jsonContainer}>
      <JsonView
        value={data}
        displayDataTypes={false}
        displayObjectSize={true}
        enableClipboard={true}
        style={{
          backgroundColor: 'transparent',
          fontFamily: 'inherit',
          fontSize: 'inherit',
        }}
      />
    </div>
  );
};
